// action - state management
import * as actionTypes from './actions';

export const initialState = {
    data: [],
    loading: true,
    totalPage: 0,
    currentPage: 0,
    totalRows: 0,
    nextPageUrl: ''
};

// ==============|| Users REDUCER ||=============== //

const productReducer = (state = initialState, action) => {
    // console.log(action);
    switch (action.type) {
        case actionTypes.FETCH_PRODUCTS:
            return {
                currentPage: action.payload.current_page,
                totalPage: action.payload.last_page,
                totalRows: action.payload.total,
                nextPageUrl: action.payload.next_page_url,
                data: [...action.payload.data]
            };
        case actionTypes.FETCH_PRODUCTS_NEXT:
            return {
                currentPage: action.payload.current_page,
                totalPage: action.payload.last_page,
                totalRows: action.payload.total,
                nextPageUrl: action.payload.next_page_url,
                data: [...state.data, ...action.payload.data]
            };
        case actionTypes.FETCH_SEARCH_PRODUCTS:
            return {
                currentPage: action.payload.current_page,
                totalPage: action.payload.last_page,
                totalRows: action.payload.total,
                nextPageUrl: action.payload.next_page_url,
                data: [...action.payload.data]
            };
        case actionTypes.ADD_PRODUCT:
            return {
                ...state,
                data: [...state.data, ...action.payload]
            };
        case actionTypes.UPDATE_PRODUCT:
            return {
                ...state,
                data: state.data.map((x) => {
                    if (x.id === action.id) {
                        x = action.payload;
                    }
                    return x;
                })
            };
        case actionTypes.ACTIVATE_PRODUCT:
            return {
                ...state,
                data: state.data.map((x) => {
                    if (x.id === action.payload.id) {
                        // x.status = x.status === 0 ? 1 : 0;
                        x.comment = action.payload.comment;
                    }
                    return x;
                })
            };
        case actionTypes.FEATURED_PRODUCT:
            return {
                ...state,
                data: state.data.map((x) => {
                    if (x.id === action.payload.id) {
                        x.is_fetured = x.is_fetured === 0 ? 1 : 0;
                    }
                    return x;
                })
            };
        default:
            return state;
    }
};

export default productReducer;
